import Text from "./Text";
const initText = (element) => {
    new Text(element);
}

export {
    Text,
    initText,
}
